import React from "react";
import { Link } from "react-router-dom";
const Footer = () => {
    return (
        <footer class="footer">
            <div class="footer-container container">

                <div class="footer-section company-info">
                    <img src="/assets/img/Leapat_footer_logo.png" alt="Company Logo" class="footer-logo" />
                    <div class="main-info-title">
                        <p class="info-title">Location:</p>
                        <p><a href="#" class="footer-link">Leapat International LLC Fort Worth-TX, USA</a></p></div>
                    <div class="main-info-title"><p class="info-title">Phone Number:</p>
                        <p><a href="tel:+14016603457" class="footer-link">+1-401-660-3457</a></p></div>
                    <div class="main-info-title"><p class="info-title">Email:</p>
                        <p><a href="mailto:hiten@leapatllc.com" class="footer-link">hiten@leapatllc.com</a></p></div>
                </div>


                <div class="footer-section company-info2">
                    <h5>Quick Links</h5>
                    <ul>
                        <li> <Link to="/">Home</Link></li>
                        <li><Link key={5} to={`/category/${5}`}>Collection</Link></li>
                        <li><Link to="/warranty">Resource</Link></li>
                        <li> <Link to="/contact">Contact Us</Link></li>
                        <li><Link to="/admin">Admin</Link></li>
                    </ul>
                </div>


                <div class="footer-section company-info3">
                    <h5>Opening Hours</h5>
                    <p><strong>Monday - Friday:</strong><br />09:00 AM - 09:00 PM</p>
                    <p><strong>Saturday - Sunday:</strong><br />09:00 AM - 12:00 PM</p>
                </div>
            </div>


            <div class="footer-bottom container">
                <p class="footer-text">
                    © {new Date().getFullYear()} Simple Leapat International. All Rights Reserved. Developed by
                    <a href="https://rajshah.co.in/" class="footer-link"> Rajshah</a>
                </p>
                <div class="social-media">
                    <span>Social Media</span>
                    <a href="#"><img src="/assets/img/leapat_facebook.png" alt="Facebook" /></a>
                    <a href="#"><img src="/assets/img/leapat_linkedin.png" alt="LinkedIn" /></a>
                </div>
            </div>
        </footer>


    );
};

export default Footer;
